import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';
import styled from 'styled-components';

export const StyledNewListingForm = styled.div`
  .row {
    display: flex;
    gap: 24px;
    align-items: flex-start;

    @media (max-width: ${breakpoints.lg}px) {
      flex-direction: column;
      gap: 0;

      > * {
        width: 100%;
        margin-bottom: 0;
        margin-top: 10px;
      }
    }
  }

  .listing-publication-dates {
    @media (max-width: ${breakpoints.lg}px) {
      .row {
        flex-direction: column;
        gap: 0;
        
        .publication-start-date,
        .publication-end-date {
          width: 100%;
          margin-bottom: 15px;
          margin-top: 5px;
        }
        
        .extend-days {
          margin-top: 10px;
        }
      }
      .extend-days {
        margin-top: 5px;
      }
    }
  }

  .delivery-radius {
    @media (max-width: ${breakpoints.lg}px) {
      flex-direction: column;
      gap: 0;
      
      > * {
        width: 100%;
        margin-bottom: 15px;
        margin-top: 0;
      }  
    }
  }
  

  .name-title,
  .identifier,
  .transaction-type,
  .listing-description,
  .reservation-purchase-number,
  .publication-start-date,
  .publication-end-date,
  .extend-days {
    flex: 1;
  }

  .address-finder {
    margin-bottom: 0;
  }

  .identifier {
    .ant-input {
      background-color: ${(props) => props.theme.readOnlyBg};
    }
  }

  .listing-description {
    .ant-input {
      min-height: 125px;
    }
  }

  .listing-address {
    .anticon {
      margin-left: 6px;
      color: ${(props) => props.theme.manslauksZils};
      font-size: 14px;
    }
  }

  .listing-publication-dates {
    .ant-input-number-affix-wrapper {
      width: 270px;
      display: flex;
      flex-direction: row;

      @media (max-width: ${breakpoints.lg}px) {
        width: 100%;
      }
    }

    .ant-picker {
      width: 100%;
    }
  }

  .delivery-radius {
    .ant-input-number {
      width: 100%;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 15px;

    .listing-publication-dates {
      .row {
        gap: 30px;
        margin-bottom: 15px;
      }
      .ant-form-item {
        margin-bottom: 0;
      }
    }

    .delivery-radius {
      display: flex;
      flex-direction: column;
      gap: 15px;

      .ant-form-item {
        margin-bottom: 0;
      }
    }

    .row {
      flex-direction: column;
      gap: 10px;

      .ant-form-item {
        margin-bottom: 0;
      }

      div {
        width: 100%;
      }
    }
  }
`;

export const StyledNewListingProductsForm = styled.div`
  .products-items {
    margin-bottom: 24px;
  }

  .products-priority {
    margin-bottom: 24px;
  }

  .cards-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;

    .add-product-card {
      background: ${(props) => props.theme.filterBackground};
    }

    .validation-error-message {
      color: ${(props) => props.theme.red};
      margin-top: 12px;
      margin-bottom: 12px;
    }
  }

  .form {
    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: 8px;
    padding: 20px;

    @media (max-width: ${breakpoints.lg}px) {
      padding: 12px;

      .ant-form-item {
        margin-bottom: 0;
      }
    }

    .required-quantity,
    .min-quantity {
      flex: 1;
    }

    .ant-input-number {
      width: 100%;
    }

    .row {
      display: flex;
      gap: 24px;
      align-items: flex-start;

      @media (max-width: ${breakpoints.lg}px) {
        flex-direction: column;
        gap: 0;

        > * {
          width: 100%;
        }
      }
    }

    .admin {
      justify-content: space-between;
    }

    .form-header {
      display: flex;
      justify-content: space-between;
    }

    .allow-smaller-quantity {
      .ant-form-item {
        margin: 0;
      }
    }

    .quality-marks {
      padding-top: 20px;
      width: 100%;

      .ant-checkbox-group {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-auto-flow: row dense;
        gap: 15px;

        .quality-mark-primary {
          grid-column: 1;
        }

        .quality-mark-secondary {
          grid-column: 2;
        }

        @media (max-width: ${breakpoints.lg}px) {
          grid-template-columns: 1fr;

          .quality-mark-primary,
          .quality-mark-secondary {
            grid-column: auto;
          }
        }
      }

      .checkboxes {
        @media (max-width: ${breakpoints.lg}px) {
          margin-bottom: 5px;
        }
      }
    }

    .form-actions {
      border-top: 1px solid ${(props) => props.theme.colorBorder};
      padding-top: 20px;
      display: flex;
      justify-content: flex-end;
      gap: 10px;

      .add-button {
        text-decoration: underline;
      }
    }
  }

  &.form-overlay {
    position: relative;

    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${(props) => props.theme.halfBlack};
      z-index: 1100;
    }

    .form {
      position: relative;
      z-index: 1101;
    }
  }

  .quantity-and-unit {
    width: 100%;
    display: flex;
    margin-bottom: 16px;

    @media (max-width: ${breakpoints.lg}px) {
      margin-top: 10px;
      margin-bottom: 5px;
    }

    .quantity-input {
      flex: 1;
      border-right: none;

      .ant-form-item {
        margin-bottom: 0;
      }

      .ant-input-number {
        border-right: 1px solid transparent;
      }

      .ant-input-number:hover {
        border-right: 1px solid ${(props) => props.theme.black};
      }

      .ant-input-number:focus-within {
        border-right: 1px solid ${(props) => props.theme.black};
      }
    }

    .ant-select {
      height: 100%;
      width: 75px;
      margin-top: 32px;

      @media (max-width: ${breakpoints.lg}px) {
        margin-top: 30px;
      }

      .ant-form-item {
        margin-bottom: 0;
      }

      .ant-select-selector {
        background: ${(props) => props.theme.inputAddonBg};
      }

      .ant-select-dropdown {
        min-width: 200px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-form-item {
      margin-bottom: 10px;
    }
    .category-sel-wrap {
      .admin {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;

        .category-selector-item {
          width: 100%;

          .ant-select {
            min-width: 100%;
            max-width: 100%;
          }
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .quality-marks {
      .ant-checkbox-group {
        grid-template-columns: 1fr !important;
      }
    }

    .quantity-and-unit {
      .ant-select {
        margin-top: 33px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .quantity-and-unit {
      .ant-select {
        margin-top: 32px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-form-item-required {
      white-space: nowrap;
    }

    .quantity-and-unit {
      .ant-select {
        margin-top: 29px;
      }
    }
  }
`;

export const StyledNewListingDeliveryConditionsForm = styled.div`
  .delivery-type-selection {
    .ant-radio-group {
      width: 100%;

      @media (max-width: ${breakpoints.lg}px) {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }

  .form-row {
    margin: 0;
  }

  .quantity-and-unit {
    width: 100%;
    display: flex;

    .quantity-input {
      flex: 1;
      border-right: none;

      .ant-input-number {
        border-right: 1px solid transparent;
      }

      .ant-input-number:hover {
        border-right: 1px solid ${(props) => props.theme.black};
      }

      .ant-input-number:focus-within {
        border-right: 1px solid ${(props) => props.theme.black};
      }
    }

    .ant-select {
      height: 100%;
      min-width: 200px;
      margin-top: 32px;

      @media (max-width: ${breakpoints.lg}px) {
        margin-top: 29px;
      }

      .ant-select-selector {
        background: ${(props) => props.theme.inputAddonBg};
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .delivery-type-selection {
      .ant-radio-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .quantity-and-unit{
      .ant-select {
        margin-top: 30px;
        min-width: 150px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-form-item-label {
      label {
        white-space: nowrap;
      }
    }

    .quantity-and-unit{
      .ant-select {
        margin-top: 29px;
      }
    }
  }
`;

export const StyledNewListingContractTermsForm = styled.div`
  .contract-terms {
    .row {
      display: flex;
      gap: 24px;

      @media (max-width: ${breakpoints.lg}px) {
        flex-direction: column;
        gap: 0;

        > * {
          width: 100%;
        }
      }
    }

    .date {
      flex: 1;

      @media (max-width: ${breakpoints.lg}px) {
        width: 100%;
      }

      .ant-picker {
        width: 100%;
      }
    }

    .textarea {
      .ant-input {
        min-height: 100px;
      }
    }

    .info-label {
      margin-top: 4px;
      font-style: italic;
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .contract-terms {
      display: flex;
      flex-direction: column;
      gap: 20px;

      .row {
        display: flex;
        /* flex-direction: column; */
        gap: 20px !important;
      }
      
      .ant-form-item {
        margin-bottom: 0;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .contract-terms {
      .row {
        flex-direction: column;
        gap: 10px;
      }
    }
  }
`;

export const StyledListingSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .summary-section {
    padding: 2px;

    .summary-section-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 16px;
      color: ${(props) => props.theme.colorText};
    }

    .summary-section-content {
      display: flex;
      flex-direction: column;
      gap: 0;

      .contract-files-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }

    .summary-info-row {
      display: flex;
      gap: 40px;
      padding: 12px 0;

      .summary-info-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;

        &.summary-info-full-width {
          flex: 1 1 100%;
        }

        .summary-info-label {
          font-size: 16px;
          font-weight: 500;
          color: ${(props) => props.theme.black};
          font-family: ${(props) => props.theme.fontFamily};
        }

        .summary-info-value {
          font-size: 14px;
          color: ${(props) => props.theme.colorText};
          word-break: break-word;

          .quality-marks-list {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 4px;
          }

          .quality-mark-item {
            display: block;
          }
        }
      }
    }

    .summary-field {
      display: flex;
      gap: 8px;
      padding: 8px 0;

      .summary-field-label {
        font-weight: 500;
        color: ${(props) => props.theme.colorTextSecondary};
      }

      .summary-field-value {
        color: ${(props) => props.theme.colorText};
      }
    }

    .summary-delivery-card {
      position: relative;
      padding: 12px;
      border: 1px solid ${(props) => props.theme.colorBorderSecondary};
      border-radius: 4px;

      .delivery-card-title {
        font-weight: 500;
        margin-bottom: 12px;
        color: ${(props) => props.theme.colorText};
      }

      .summary-field {
        padding: 4px 0;
      }

      .delivery-actions {
        position: absolute;
        top: 12px;
        right: 12px;
        display: flex;

        .action-button {
          padding: 4px 8px;
          height: auto;
          border: none;
          background: none;
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            background: none;
            color: ${(props) => props.theme.black};
          }

          &.danger {
            color: ${(props) => props.theme.red};

            &:hover {
              color: ${(props) => props.theme.red};
            }
          }
        }
      }
    }

    .summary-product-item,
    .summary-delivery-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      border: 1px solid ${(props) => props.theme.colorBorderSecondary};
      border-radius: 4px;
      margin-bottom: 12px;
      gap: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .product-tag,
      .delivery-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 32px;
        height: 32px;
        background-color: ${(props) => props.theme.colorPrimary};
        color: ${(props) => props.theme.white};
        border-radius: 16px;
        font-weight: 600;
        font-size: 14px;
      }

      .delivery-tag {
        align-self: flex-start;
        margin-top: 5px;
      }

      .product-info {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .product-name {
          font-weight: 500;
          color: ${(props) => props.theme.colorText};
        }

        .product-details {
          font-size: 14px;
          color: ${(props) => props.theme.colorTextSecondary};
        }

        .product-quality-mark-logos {
          display: flex;
          gap: 8px;
          margin-top: 8px;

          img {
            width: 40px;
            height: auto;
            aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};
            object-fit: contain;
          }
        }
      }

      .delivery-info {
        flex: 1;

        .delivery-address {
          font-weight: 500;
          margin-bottom: 4px;
          color: ${(props) => props.theme.colorText};
        }

        .delivery-details {
          font-size: 14px;
          color: ${(props) => props.theme.colorTextSecondary};
        }

        .delivery-products {
          margin-top: 12px;
          display: flex;
          flex-direction: column;
          gap: 5px;

          .delivery-products-title {
            margin-bottom: 0;
          }

          .delivery-product-row {
            display: flex;
            align-items: center;
            background-color: ${(props) => props.theme.colorBgContainer};
            border-radius: 4px;

            .delivery-product-name {
              font-size: 14px;
              color: ${(props) => props.theme.colorText};
            }

            .delivery-product-qty {
              font-size: 14px;
              font-weight: 500;
              color: ${(props) => props.theme.colorTextSecondary};
            }
          }
        }
      }

      .product-actions {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        gap: 4px;

        .action-buttons {
          display: flex;
          gap: 0;
          justify-content: end;
        }

        .action-button {
          padding: 4px 8px;
          height: auto;
          border: none;
          background: none;
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            background: none;
            color: ${(props) => props.theme.black};
          }

          &.danger {
            color: ${(props) => props.theme.red};

            &:hover {
              color: ${(props) => props.theme.red};
            }
          }
        }

        .product-delete-disabled-text {
          font-size: 12px;
          font-style: italic;
          color: ${(props) => props.theme.colorTextSecondary};
          white-space: nowrap;
        }
      }

      .delivery-actions {
        display: flex;
        align-self: flex-start;

        .action-button {
          padding: 4px 8px;
          height: auto;
          border: none;
          background: none;
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            background: none;
            color: ${(props) => props.theme.black};
          }

          &.danger {
            color: ${(props) => props.theme.red};

            &:hover {
              color: ${(props) => props.theme.red};
            }
          }
        }
      }
    }
  }

  @media (max-width: ${breakpoints.lg}px) {
    .summary-section .summary-info-row {
      flex-direction: column;
      gap: 0;
      padding: 0;

      > .summary-info-column {
        padding: 8px 0;
        border-bottom: 1px solid ${(props) => props.theme.border};
      }
    }

    .summary-section-content > div[aria-hidden] {
      display: none !important;
    }

    .summary-info-value .quality-marks-list {
      grid-template-columns: 1fr;
    }

    .summary-product-item,
    .summary-delivery-item {
      flex-wrap: wrap;
    }

    .summary-section .summary-product-item .product-actions,
    .summary-section .summary-delivery-item .delivery-actions {
      align-self: flex-end;
    }

    .summary-section:first-child .summary-section-title {
      display: none;
    }

    .summary-section:nth-child(2) > div[aria-hidden]:first-child {
      display: none !important;
    }

    .summary-section:nth-child(2) .summary-section-title {
      margin-top: 0;
    }
  }
`;
